// extracted by mini-css-extract-plugin
module.exports = {"h1":"CourseGrid_h1__1KFWH","h2":"CourseGrid_h2__1Hccb","p":"CourseGrid_p__1m2HU","container":"CourseGrid_container__370iy","placeholder":"CourseGrid_placeholder__1IqRA"};